import React from 'react';
import { Theme } from '../../../../Enums/Theme.enum';
import LinkButton from '../../../../Components/Button/LinkButton';
import styles from './DENTMultipleSelectList.module.scss';

interface Props<T> {
	items: T[];
	addNewItem: () => void;
	renderComponent: (item: T, index: number) => React.ReactNode;
	showAddButton?: boolean;
}

const DENTMultipleSelectList = <T,>({
	items,
	addNewItem,
	renderComponent,
	showAddButton = true,
}: Props<T>) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.items}>{items.map(renderComponent)}</div>
			{items.length > 0 && showAddButton && (
				<LinkButton
					theme={Theme.BLUE}
					title={'base.addAnother'}
					onClick={addNewItem}
				/>
			)}
		</div>
	);
};

export default DENTMultipleSelectList;
